@if (mode() === 'scheduled' && schedule(); as current) {
<div class="flex flex-col gap-4 rounded-xl border border-emerald-700/40 bg-emerald-50 px-4 py-4 dark:border-emerald-800 dark:bg-emerald-950/40 sm:flex-row sm:items-center sm:justify-between" role="status">
  <div class="min-w-0">
    <h2 class="text-base font-semibold text-emerald-950 dark:text-emerald-100">Weekly report scheduled · {{ current.scheduleDescription }}</h2>
    <p class="mt-1 text-sm text-emerald-900 dark:text-emerald-200">Next delivery {{ current.nextRunLocal }} to {{ current.recipientCount }} recipient{{ current.recipientCount === 1 ? '' : 's' }}</p>
  </div>
  <div class="flex shrink-0 flex-wrap gap-2">
    <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary" (click)="viewLatest.emit()">View latest report</button>
    <button type="button" class="btn-shout btn-shout-sm btn-shout-primary" (click)="openSchedule.emit()">Edit schedule</button>
  </div>
</div>
} @else {
<div class="flex flex-col gap-4 rounded-xl border border-primary/30 bg-primary/5 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
  <div class="flex min-w-0 gap-3">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mt-0.5 size-5 shrink-0 text-primary" aria-hidden="true">
      <rect width="20" height="16" x="2" y="4" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
    <div>
      <h2 class="text-base font-semibold text-primary">Get this report in your inbox every week</h2>
      <p class="mt-1 text-sm text-secondary">Choose a day, time and recipients. SHOUT emails a branded summary and a link to the full report.</p>
    </div>
  </div>
  <div class="flex shrink-0 flex-wrap gap-2">
    <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary" (click)="preview.emit()">Preview report</button>
    <button type="button" class="btn-shout btn-shout-sm btn-shout-primary" (click)="openSchedule.emit()">Schedule weekly report</button>
  </div>
</div>
}
